//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { MediaAtomPositionMixins } from '@components/atoms/media/MediaAtomPositionMixins';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  quantity: number;
}

/**
 * The OverflowText atom renders a styled string used to indicate
 * how many items are represented by a BlurredMedia atom.
 */
const OverflowText = ({ className, quantity }: Props) => {
  return <Text className={className}>{quantity} More</Text>;
};

const Text = styled.div(
  ({ theme }) => `
  font-weight: ${theme.fontWeights.semiBold};
  color: ${theme.colors.white};
`,
);

/**
 * Most usages of this atom center it with padding, so we
 * export a version with these styles attached for convenience.
 */
export const CenteredOverflowText = styled(OverflowText)`
  ${MediaAtomPositionMixins.Middle}
  text-align: center;
`;

export default OverflowText;
